import { KatDataTable } from '@amzn/katal-react';
import { TranslateFn } from 'src/i18next-arb-shim/useTranslation';
import { StringGroup } from 'src/generated/graphql';

const formatDetailsButton = (
  rowIndex: number,
  rowData: StringGroup,
  previouslyRenderedElement: any,
  t: TranslateFn,
  history: any
): KatDataTable.FormatterConfig => {
  const element = previouslyRenderedElement
    ? previouslyRenderedElement
    : document.createElement('kat-button');

  element.id = rowIndex;

  const url = `/sourceReview/messageGroup/${rowData.stringGroupName}`;

  element.href = url;
  element.variant = 'primary';
  element.label = t('review-button');
  element.onclick = (event: React.MouseEvent) => {
    if (!url.length) {
      return;
    }
    event.preventDefault();
    history.push(url, {
      from: `/sourceReview${history.location.search}`,
      stringGroup: rowData,
    });
  };

  return {
    element: element,
    attributes: { class: 'lui-source-review-table-action-col' },
  };
};

export default (
  t: TranslateFn,
  history: any
): KatDataTable.ColumnConfiguration[] => {
  return [
    {
      label: t('column-source-review-message-group'),
      property: 'stringGroupName',
    } as KatDataTable.ColumnConfiguration,
    {
      label: t('column-source-review-submitted-on'),
      property: 'sourceReviewRequestedTimestampDisplay',
    } as KatDataTable.ColumnConfiguration,
    {
      label: t('column-source-review-submitted-by'),
      property: 'sourceReviewRequester',
    } as KatDataTable.ColumnConfiguration,
    {
      label: t('column-source-review-request-id'),
      property: 'requestId',
    } as KatDataTable.ColumnConfiguration,
    {
      label: t('column-source-review-action'),
      property: 'action',
      formatter: (
        rowIndex: number,
        rowData: any,
        previouslyRenderedElement: any
      ) =>
        formatDetailsButton(
          rowIndex,
          rowData,
          previouslyRenderedElement,
          t,
          history
        ),
    } as KatDataTable.ColumnConfiguration,
  ];
};
